import React from 'react'
import { ErrorMessage } from 'core/components/validatedForm/ErrorMessage'
import Text from 'core/elements/Text'
import PhysicalNodesTable from '../cluster/deployment/form-components/PhysicalNodesTable'
import { useErrorClearingSelectUpdater } from './hooks/useErrorClearingSelectUpdater'

const defaultPhysicalNodeErrors = { title: '', message: '' }

const ClusterWorkerPhysicalNodes = ({
  params,
  getParamsUpdater,
  setError,
  disabled = false,
  physicalNodeErrors = defaultPhysicalNodeErrors,
  setPhysicalNodeErrors = undefined,
}) => {
  const handleSelectChange = useErrorClearingSelectUpdater(
    getParamsUpdater('physicalNodes'),
    setPhysicalNodeErrors,
  )
  return (
    <>
      <Text variant="body2">Select the worker nodes for cluster.</Text>
      <PhysicalNodesTable
        selectedNodes={params?.physicalNodes}
        masterPhysicalNodes={
          params?.controlPlaneType === 'custom' ? params?.masterPhysicalNodes : []
        }
        setError={setError}
        disabled={disabled}
        onSelectChange={handleSelectChange}
      />
      {physicalNodeErrors && (
        <ErrorMessage data-testid="physical-node-error">{physicalNodeErrors.message}</ErrorMessage>
      )}
    </>
  )
}

export default ClusterWorkerPhysicalNodes
